import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Option } from '@euler/model';
import { OrderReservationType } from '@euler/model/enum';
import { memo } from 'react';
import { Path, Svg } from 'react-native-svg';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { IconWrapper } from '../components/IconWrapper';
import InlineRadios from '../components/InlineRadios';
import { Row } from '../components/Row';
import { RowErrorText } from '../components/RowErrorText';

const kOptions: Option<OrderReservationType>[] = [
  { value: OrderReservationType.Reserved, text: '已预约' },
  {
    value: OrderReservationType.NonReserved,
    text: '未预约',
  },
];

export const ReservationTypeRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor } = theme;

    return (
      <Row
        errorProp="reservationType"
        note={<RowErrorText error={form.reservationType.error} />}
        required={required}
        title="服务预约"
        icon={
          <IconWrapper>
            <RowIcon color={iconColor} />
          </IconWrapper>
        }
        detail={
          <InlineRadios
            options={kOptions}
            value={form.reservationType.value}
            disabled={props.disabled}
            onChange={form.reservationType.update}
          />
        }
        {...props}
      />
    );
  },
);

const RowIcon = memo(({ width, height, color, style, ...props }: IconProps) => {
  const { rpx } = useResponsiveContext();
  return (
    <Svg
      viewBox="0 0 21 20.9714"
      width={width ?? rpx(21)}
      height={height ?? rpx(21)}
      style={style}
      fill="none"
      {...props}
    >
      <Path
        d="M15.069 9.12836C14.8396 9.12836 14.615 9.1427 14.3951 9.1666C14.3425 9.17137 14.2852 9.18092 14.2327 9.18571C14.2183 9.18571 14.1992 9.19049 14.1848 9.19049C14.1418 9.19527 14.1036 9.20482 14.0605 9.20961C14.0463 9.20961 14.0319 9.21439 14.0176 9.21439C13.965 9.22394 13.9172 9.23351 13.8646 9.24306C13.8502 9.24783 13.8359 9.24783 13.8217 9.25262C13.7833 9.26218 13.7451 9.27173 13.7069 9.27652C13.6925 9.2813 13.6735 9.28607 13.6591 9.28607C13.6113 9.30042 13.5587 9.30997 13.511 9.32431C13.5013 9.32431 13.4966 9.32909 13.4871 9.32909C13.4441 9.34343 13.3962 9.35298 13.3533 9.36732C13.3389 9.3721 13.3198 9.37688 13.3054 9.38165C13.2672 9.39122 13.229 9.40555 13.1908 9.41989C13.1764 9.42467 13.1669 9.42944 13.1525 9.43423C13.1047 9.44856 13.0569 9.46768 13.0092 9.4868L12.9661 9.50114C12.9326 9.51547 12.8944 9.52982 12.861 9.54416C12.8467 9.54893 12.8275 9.55849 12.8132 9.56326C12.7654 9.58238 12.7224 9.6015 12.6746 9.62062L12.6459 9.63496C12.6077 9.64929 12.5742 9.66841 12.536 9.68753C12.5168 9.69708 12.4978 9.70665 12.4834 9.71143C12.4739 9.7162 12.4595 9.72098 12.45 9.72577C12.4404 9.73055 12.426 9.73532 12.4165 9.74489L12.3018 9.80223C12.2827 9.81178 12.2588 9.82613 12.2396 9.83569C12.2062 9.8548 12.168 9.87392 12.1345 9.89304C12.1106 9.90738 12.0916 9.91693 12.0676 9.93127C12.0342 9.95039 11.996 9.97429 11.9625 9.99341C11.9434 10.0077 11.9242 10.0173 11.9052 10.0316L11.7474 10.132C11.6901 10.1702 11.6375 10.2085 11.5801 10.2467C11.561 10.261 11.5466 10.2706 11.5276 10.2849L11.4128 10.371C11.3938 10.3853 11.3794 10.3996 11.3604 10.4092C11.3125 10.4474 11.2695 10.4809 11.2264 10.5191C11.2217 10.5239 11.2122 10.5287 11.2074 10.5382C11.1548 10.5813 11.1069 10.629 11.0544 10.6721L11.0114 10.7151C10.9779 10.7485 10.9445 10.782 10.911 10.8107L10.8585 10.8632L10.7725 10.9492C10.7056 11.0209 10.6387 11.0926 10.5717 11.1691C10.5239 11.2217 10.4761 11.279 10.4331 11.3364C10.3854 11.3937 10.3423 11.4511 10.2993 11.5132C9.56812 12.4977 9.13794 13.7212 9.13794 15.0403C9.13794 18.3189 11.7952 20.9713 15.069 20.9713C16.4645 20.9713 17.7501 20.4886 18.7633 19.6809C19.2891 19.2604 19.743 18.7538 20.1016 18.185C20.675 17.2722 21 16.1969 21 15.0403C21 11.7856 18.3428 9.12836 15.069 9.12836ZM19.3704 15.9914C19.2174 16.6987 18.8923 17.3439 18.4431 17.8792C17.6355 18.8446 16.4215 19.4611 15.0642 19.4611C12.6364 19.4611 10.6625 17.4873 10.6625 15.0594C10.6625 13.7594 11.2312 12.5885 12.1298 11.7808C12.6506 11.3125 13.2815 10.9684 13.9841 10.7915C14.333 10.7055 14.6914 10.6577 15.069 10.6577C17.4968 10.6577 19.4707 12.6315 19.4707 15.0594C19.4707 15.3796 19.4373 15.6903 19.3704 15.9914Z"
        fillRule="evenodd"
        fill={color}
      />
      <Path
        d="M8.37805 10.1129C6.62402 9.53461 5.35278 7.87621 5.35278 5.93105C5.35278 3.50319 7.32654 1.52936 9.75439 1.52936C12.1823 1.52936 14.1561 3.50319 14.1561 5.93105C14.1561 6.62881 13.9937 7.28358 13.7069 7.87143C14.1466 7.79495 14.6006 7.75194 15.0642 7.75194C15.179 7.75194 15.2888 7.75194 15.3988 7.75673C15.5851 7.18321 15.6855 6.5667 15.6855 5.93105C15.6855 2.65726 13.0282 0 9.75439 0C6.48071 0 3.82812 2.65248 3.82812 5.93105C3.82812 7.9001 4.78882 9.64931 6.26562 10.7246C2.98706 12.0724 0.559204 15.0546 0 18.663L1.54846 18.663C1.86389 16.9281 2.70032 15.3318 3.97632 14.0558C5.15686 12.8753 6.6145 12.0724 8.20117 11.7092C8.23938 11.6996 8.27283 11.6948 8.31116 11.6853C8.55005 11.2647 8.82727 10.868 9.13794 10.5048C9.19531 10.4379 9.2478 10.3757 9.30518 10.3136C8.98499 10.2754 8.67432 10.2085 8.37805 10.1129Z"
        fillRule="evenodd"
        fill={color}
      />
      <Path
        d="M15.2698 15.112L15.2698 12.5168L13.6782 12.5168L13.6782 16.7035L17.406 16.7035L17.406 15.112L15.2698 15.112Z"
        fillRule="evenodd"
        fill={color}
      />
    </Svg>
  );
});
